import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { mechanicalData } from '../../data/departmentalData/mechanical';

const Mechanical = () => {
  return <TemplatePage data={mechanicalData} />;
};

export default Mechanical;
